<div class="isf-batch-review-header">
  <div class="isf-batch-review-header-text">
    <div class="isf-batch-review-header-text-ref-number">{{ referenceNumber }}</div>

    <div class="isf-batch-review-header-text-checkbox">
      <div class="custom-control custom-checkbox">
        <input type="checkbox" class="custom-control-input" id="isf-batch-item-review" [formControl]="isConfirmedFc" />
        <label class="custom-control-label" for="isf-batch-item-review">
          <span>{{ "BUTTON.CONFIRM" | translate }}</span>
        </label>
      </div>
    </div>
  </div>
  <div class="isf-batch-review-header-close" (click)="close.emit()">×</div>
</div>

<ng-container *ngIf="!isLoading && !!isf">
  <desktop-isf-summary-receiving-party
    [company]="company"
    [importer]="importer"
    [consignee]="consignee"
    [buyer]="buyer"
    [shipTo]="shipTo"
    [isImporterEdited]="isImporterEdited"
    [isConsigneeEdited]="isConsigneeEdited"
    [isBuyerEdited]="isBuyerEdited"
    [isShipToEdited]="isShipToEdited"
    [isEditMode]="true"
    (edit)="editEntity($event)"
  ></desktop-isf-summary-receiving-party>

  <desktop-isf-summary-shipping-party
    [importer]="importer"
    [seller]="seller"
    [consolidator]="consolidator"
    [staffingLocation]="staffingLocation"
    [isSellerEdited]="isSellerEdited"
    [isConsolidatorEdited]="isConsolidatorEdited"
    [isStaffingLocationEdited]="isStaffingLocationEdited"
    [isfState]="isf?.state"
    [isEditMode]="true"
    (edit)="editEntity($event)"
  ></desktop-isf-summary-shipping-party>

  <isf-data-card
    cardTitle="LABELS.INTERNATIONAL_HTS_CODE"
    imgSrc="assets/icons/hts.svg"
    [dataIsValid]="isValidHTS"
    *ngIf="!invoices?.length"
  >
    <desktop-shipment-details-hts
      body
      [manufacturers]="manufacturers"
      [invoices]="[]"
      (editMF)="editEntity($event)"
    ></desktop-shipment-details-hts>

    <div class="isf-batch-review-card-footer" footer *ngIf="!manufacturers.length">
      <button type="button" class="btn btn-link" (click)="editEntity({ id: null, entityType: enumEntityModelCode.MANUFACTURER })">
        <i class="fa fa-plus-circle"></i>
        <span>{{ "LABELS.ADD_MANUFACTURER" | translate }}</span>
      </button>
    </div>
  </isf-data-card>

  <desktop-isf-summary-hts
    *ngIf="invoices?.length"
    [manufacturers]="manufacturers"
    [invoices]="invoices"
    [isEditMode]="true"
    (edit)="editEntity($event)"
    (editHTS)="editHTS($event)"
    (deleteHTS)="onDeleteManufacturerHTS($event)"
    (deleteMF)="onDeleteManufacturer($event)"
    (addMF)="editEntity({ id: null, entityType: enumEntityModelCode.MANUFACTURER })"
  ></desktop-isf-summary-hts>

  <desktop-isf-summary-shipment-details
    [isf]="isf"
    [company]="company"
    [isEditMode]="true"
    (editShipmentType)="editShipmentType($event)"
    (editBL)="editBL()"
  ></desktop-isf-summary-shipment-details>

  <desktop-summary-upload-isf-documents
    [company]="company"
    [isf]="isf"
    [isEditMode]="true"
    (downloadAllFiles)="onDownloadAllFiles($event)"
  ></desktop-summary-upload-isf-documents>
</ng-container>

<loading-spinner [show]="isLoading"></loading-spinner>
